












































































































































import axios from 'axios';
import { keyBy } from 'lodash-es';
import Vue from 'vue';
import { Utils } from '@/Utils';
import { User, Campaign, Role } from '@/types';
import RegionsDialog from './RegionsDialog.vue';
import EditUserDialog from './EditUserDialog.vue';
import UserCampaignsDialog from './UserCampaignsDialog.vue';

declare const $: any;

interface Data {
    users: User[];
    campaigns: Record<number, Campaign>;
    Role: typeof Role;
}

export default Vue.extend({
    components: {
        RegionsDialog,
        UserCampaignsDialog,
        EditUserDialog
    },
    created: function() {
        const usersReq = axios
            .get(`${process.env.VUE_APP_API_URI}/api/admin/users`)
            .then(res => {
                if (res.status !== 200) {
                    Utils.toastError('Unable to fetch users');
                } else {
                    this.users = res.data;
                    this.$nextTick(() => {
                        $('[data-toggle="popover"]').popover();
                    });
                }
            });

        const campaignsReq = axios
            .get(`${process.env.VUE_APP_API_URI}/api/admin/weblinks`)
            .then(res => {
                if (res.status !== 200) {
                    Utils.toastError('Unable to fetch campaigns');
                } else {
                    this.campaigns = keyBy(res.data, 'id');
                }
            });
    },
    data: function(): Data {
        return {
            users: [],
            campaigns: {},
            Role: Role,
        };
    },
    methods: {
        showCampaigns(user: User) {
            this.$modal.show('campaigns', {
                user,
                campaigns: this.campaigns,
            });
        },
        editUser(user: User) {
            this.$modal.show('editUser', {
                user,
            });
        },
        editRegions(user: User) {
            this.$modal.show('regions', {
                user,
            });
        },
        approveUser(user) {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/approve-user`, {
                    user: user.userName,
                })
                .then(res => {
                    const updatedUser = this.users.find(
                        usr => usr.userName === user.userName
                    );

                    updatedUser.disabled = false;
                })
                .catch(err => {
                    console.error(err);
                    Utils.toastError('Failed to Approve user');
                });
        },
    },
});
